var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import http from 'app/services/http';
import { TASKS_PAGE_SIZE } from 'app/store/taskList';
import moment from 'moment';
export { taskLoad, TASKS_PAGE_SIZE } from 'app/store/taskList';
const typeLabels = {
    speed_limit: 'Превышения скорости',
    parking_time: 'Стоянки',
    signal_off: 'Потери связи',
    user_log: 'Действия пользователей',
    flight: 'Рейсы',
    drains: 'Сливы',
    sep_events: 'События СЭП',
};
export function getTaskParams(task) {
    if (!(task === null || task === void 0 ? void 0 : task.params)) {
        return {};
    }
    if (typeof task.params === 'string') {
        try {
            return JSON.parse(task.params);
        }
        catch (_a) {
            return {};
        }
    }
    return task.params;
}
export function getReportTypeName(task, typeItems = []) {
    const typeItem = typeItems.find((item) => item.method === task.type);
    if (typeItem === null || typeItem === void 0 ? void 0 : typeItem.name) {
        return typeItem.name;
    }
    const byName = typeItems.find((item) => item.name === task.type);
    if (byName === null || byName === void 0 ? void 0 : byName.name) {
        return byName.name;
    }
    if (task.typeName) {
        return task.typeName;
    }
    return typeLabels[task.type] || task.type;
}
export function buildReportDownloadName(task, typeItems = []) {
    const name = getReportTypeName(task, typeItems);
    const { from, to, timezone } = getTaskParams(task);
    const timezoneOffset = config.timezoneOffsets.find((tz) => String(tz.value) === String(timezone));
    const date = moment().format('YYYY-MM-DD HHmm');
    const fromFormatted = from ? moment(from).format('YYYY-MM-DD HHmm') : '';
    const toFormatted = to ? moment(to).format('YYYY-MM-DD HHmm') : '';
    const timeZone = (timezoneOffset === null || timezoneOffset === void 0 ? void 0 : timezoneOffset.title) || '+03:00';
    return `${date} ${name} ${fromFormatted} - ${toFormatted} ${timeZone}.xlsx`;
}
const initialState = {
    items: [],
    page: 1,
    total: 0,
    totalPages: 1,
    loading: false,
    socketStatus: 'CLOSED',
    sortField: 'created_at', // поле по умолчанию
    sortOrder: 'DESC', // порядок
};
export const taskReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'TASK_ADD': {
            const newTask = action.payload;
            // Проверяем, нет ли уже такой задачи
            if (state.items.some((t) => t.id === newTask.id)) {
                return state;
            }
            const total = state.total + 1;
            const totalPages = Math.max(1, Math.ceil(total / TASKS_PAGE_SIZE));
            if (state.page !== 1) {
                return Object.assign(Object.assign({}, state), { total, totalPages });
            }
            return Object.assign(Object.assign({}, state), { total,
                totalPages, items: [Object.assign(Object.assign({}, newTask), { params: getTaskParams(newTask) }), ...state.items].slice(0, TASKS_PAGE_SIZE) });
        }
        case 'TASK_UPDATE_STATUS': {
            const { taskId, status, result } = action.payload;
            return Object.assign(Object.assign({}, state), { items: state.items.map((task) => (task.id === taskId ? Object.assign(Object.assign({}, task), { status, result, updatedAt: new Date().toISOString() }) : task)) });
        }
        case 'TASK_SET_ITEMS': {
            const payload = action.payload;
            const rawItems = Array.isArray(payload) ? payload : payload === null || payload === void 0 ? void 0 : payload.items;
            const items = Array.isArray(rawItems) ? rawItems : [];
            return Object.assign(Object.assign({}, state), { items: items.map((task) => (Object.assign(Object.assign({}, task), { params: getTaskParams(task) }))), page: Array.isArray(payload) ? state.page : Number(payload === null || payload === void 0 ? void 0 : payload.page) || 1, total: Array.isArray(payload) ? items.length : Number(payload === null || payload === void 0 ? void 0 : payload.total) || 0, totalPages: Array.isArray(payload) ? state.totalPages : Number(payload === null || payload === void 0 ? void 0 : payload.totalPages) || 1, loading: false });
        }
        case 'TASK_LOADING':
            return Object.assign(Object.assign({}, state), { loading: true });
        case 'TASK_REMOVE': {
            return Object.assign(Object.assign({}, state), { items: state.items.filter((t) => t.id !== action.payload.taskId) });
        }
        case 'TASK_SET_SORT': {
            const { field, order } = action.payload;
            return Object.assign(Object.assign({}, state), { sortField: field, sortOrder: order });
        }
        case 'TASK_SOCKET_STATUS': {
            return Object.assign(Object.assign({}, state), { socketStatus: action.payload.status });
        }
        default:
            return state;
    }
};
export const setTaskSort = (field, order) => ({
    type: 'TASK_SET_SORT',
    payload: { field, order },
});
// Thunk для скачивания файла готового отчёта
export function taskDownload(taskOrId) {
    return function taskDownloadThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const state = getState();
            const task = typeof taskOrId === 'object' ? taskOrId : (_b = (_a = state.task) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.find((item) => item.id === taskOrId);
            if (!task) {
                dispatch({
                    type: 'NOTIFICATION_ADD_QUEUE',
                    payload: {
                        text: 'Не удалось найти задачу для скачивания.',
                        color: 'error',
                        timeout: 5000,
                    },
                });
                return;
            }
            try {
                const typeItems = ((_c = state.report) === null || _c === void 0 ? void 0 : _c.typeItems) || [];
                const filename = buildReportDownloadName(task, typeItems);
                const response = yield http.get(`/report/task/${task.id}/download`, {
                    responseType: 'blob',
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }
            catch (error) {
                const status = error === null || error === void 0 ? void 0 : error.status;
                let text = 'Не удалось скачать файл отчёта.';
                if (status === 404) {
                    text = 'Файл отчёта не найден на сервере. Возможно, он был удалён или ещё не сформирован.';
                }
                dispatch({
                    type: 'NOTIFICATION_ADD_QUEUE',
                    payload: {
                        text,
                        color: 'error',
                        timeout: 6000,
                    },
                });
            }
        });
    };
}
export default taskReducer;
